import React from 'react';
import { FilterPopover } from '../../vyTableFilter/components/FilterPopover';
import type { FilterLine } from '../../vyTableFilter/types';
import { VyTableFilterButton } from '../vy-table-filter-button';
import type { FilterField } from '../../vyTableFilter/types';
import { useTableFilters } from '../../../../hooks/use-table-filters';

type VyTableFilterNewProps = {
  fields: FilterField[];
  onFiltersChange?: (filters: FilterLine[]) => void;
  defaultFilters?: FilterLine[];
};

export const VyTableFilterNew: React.FC<VyTableFilterNewProps> = React.memo(
  ({ fields, onFiltersChange, defaultFilters = [] }) => {
    const { anchorRef, isOpen, appliedFilters, handleClick, handleClose, handleFiltersChange } =
      useTableFilters({
        defaultFilters,
        onFiltersChange,
      });

    return (
      <>
        <VyTableFilterButton onClick={handleClick} appliedFilters={appliedFilters} />
        <FilterPopover
          anchorEl={anchorRef.current}
          open={isOpen}
          onClose={handleClose}
          fields={fields}
          onFiltersChange={handleFiltersChange}
          defaultFilters={defaultFilters}
        />
      </>
    );
  },
);
